export default {
  namespaced: true,
  billing_price: {
    title: "Precios",
    region: "Región",
    security_company: "Empresa de seguridad",
    description: "Descripción",
    profile: "Perfil",
    hours: "Horas",
    days: "Días",
    cost_per_hour: "Costo por hora",
    cost_per_shift: "Costo por turno",
  }
}